import React from "react";
import { ReactSession } from "../lib/secure_reactsession";
import { Navigate } from "react-router-dom";

export default function Home() {
  ReactSession.setStoreType("localStorage");
  const token = ReactSession.get("token");
  const user = ReactSession.get("user");

  if (user && token) {
    let workspaceId = null;
    const sessionWorkspace = ReactSession.get("workspace");

    if (sessionWorkspace) {
      workspaceId = sessionWorkspace.workspace_id;
    }

    if (workspaceId && user.role === "Researcher") {
      return <Navigate to={`/wsp/${workspaceId}`} />;
    }
    return <Navigate to="/dashboard" />;
  }

  return <Navigate to="/researcher/sign-in" />;
}
